import {IGlobalStore} from 'modules/types';

export const getAdSlots = ({adSlots}: IGlobalStore) => adSlots;